import { PropsWithChildren } from "react";
import { createPortal } from "react-dom";
import "./SidebarModal.scss";
import { CloseIcon } from "../../assets/icons";

function SidebarModal({
  isOpen,
  closeModal,
  width = 350,
  children,
}: PropsWithChildren<{
  isOpen: boolean;
  closeModal: () => void;
  width: number | string;
}>) {
  const sidebarElem = document.getElementById("lineage-sidebar");
  if (!sidebarElem) return null;
  const widthString = typeof width === "number" ? `${width}px` : width;
  return createPortal(
    <div className={`sidebar-modal ${isOpen ? "" : "d-none"}`}>
      {isOpen && (
        <>
          <div className="sidebar-background-screen" onClick={closeModal} />
          <div className="sidebar-modal-content" style={{ width: widthString }}>
            <div className="sidebar-close-button" onClick={closeModal}>
              <CloseIcon />
            </div>
            {children}
          </div>
        </>
      )}
    </div>,
    sidebarElem
  );
}

export { SidebarModal };
